module.exports = __webpack_public_path__ + "static/media/download-line.1bbf5fe5.svg";